import React from "react";
import { GridModel, PageContainer, PageRow, Spinner} from "@renta-apps/athenaeum-react-components";
import AuthorizedPage from "../../models/base/AuthorizedPage";
import WorkOrderCreationRequestsPanel from "@/pages/WorkOrderCreationRequests/WorkOrderCreationRequestsPanel/WorkOrderCreationRequestsPanel";
import WorkOrderCreationRequestsToolbarModel from "@/pages/WorkOrderCreationRequests/WorkOrderCreationRequestsToolbar/WorkOrderCreationRequestsToolbarModel";
import WorkOrderCreationRequestsToolbar from "@/pages/WorkOrderCreationRequests/WorkOrderCreationRequestsToolbar/WorkOrderCreationRequestsToolbar";
import UserInteractionDataStorage from "@/providers/UserInteractionDataStorage";
import WorkOrderCreationRequestModel from "@/models/server/WorkOrderCreationRequestModel";
import CostPool from "@/models/server/CostPool";
import CostPoolProvider from "@/providers/CostPoolProvider";
import Localizer from "@/localization/Localizer";

import styles from "./WorkOrderCreationRequests.module.scss";

interface IWorkOrderCreationRequestsProps {
}

interface IWorkOrderCreationRequestsState {
    filters: WorkOrderCreationRequestsToolbarModel;
    costPools: CostPool[];
}

export default class WorkOrderCreationRequests extends AuthorizedPage<IWorkOrderCreationRequestsProps, IWorkOrderCreationRequestsState> {
    private readonly _filterKey: string = "filter-WorkOrderCreationRequests-v2"

    public state: IWorkOrderCreationRequestsState = {
        filters: UserInteractionDataStorage.getFilters(new WorkOrderCreationRequestsToolbarModel(), this._filterKey),
        costPools: [],
    };

    private readonly _WorkOrderCreationRequestsGridRef: React.RefObject<WorkOrderCreationRequestsPanel> = React.createRef();

    private async onFiltersChange(filters: WorkOrderCreationRequestsToolbarModel): Promise<void> {
        UserInteractionDataStorage.setFilters(filters, this._filterKey);

        await this.setSpinnerAsync(true);

        await this.setState({filters});

        await this.WorkOrderCreationRequestsGrid.reloadAsync();

        await this.setSpinnerAsync(false);
    }

    private get WorkOrderCreationRequestsGrid(): GridModel<WorkOrderCreationRequestModel> {
        return this.WorkOrderCreationRequestsPanel.WorkOrderCreationRequestsGrid;
    }

    private get WorkOrderCreationRequestsPanel(): WorkOrderCreationRequestsPanel {
        return this._WorkOrderCreationRequestsGridRef.current!;
    }

    public async initializeAsync(): Promise<void> {
        const costPools = await CostPoolProvider.getCostPoolsAsync(this);

        await this.setState({ costPools });
    }

    public getTitle(): string {
        return Localizer.topNavWorkOrderCreationRequests;
    }

    public hasSpinner(): boolean {
        return true;
    }

    public render(): React.ReactNode {

        return (
            <PageContainer scale className={styles.WorkOrderCreationRequests}>
                {
                    (this.isSpinning()) &&
                    (
                        <Spinner global />
                    )
                }

                <PageRow>
                    <div className={"col w-fit-content"}>
                        <div id="WorkOrderCreationRequestsToolbar">
                            <WorkOrderCreationRequestsToolbar model={this.state.filters}
                                               userContext={this.userContext}
                                               costPools={this.state.costPools}
                                               onChange={async (model) => this.onFiltersChange(model)}
                            />
                        </div>

                        <div className={this.css(styles.main)}>
                            <div className={styles.right}>
                                <WorkOrderCreationRequestsPanel ref={this._WorkOrderCreationRequestsGridRef}
                                                 filters={this.state.filters}
                                />
                            </div>
                        </div>
                    </div>
                </PageRow>
            </PageContainer>
        );
    }

}